/*
    Users
*/
import Login from 'components/Login'
import Users from 'components/Users'
import RequestPasswordReset from 'components/RequestPasswordReset'
import PasswordResetForm from 'components/PasswordResetForm'


/*
    Systems
*/
import Systems from 'components/Systems'

// Credits
import SystemCreditsOverview from 'components/SystemCreditsOverview'
import IssueSystemCredits from 'components/IssueSystemCredits'

// Config
import SystemConfigOverview from 'components/SystemConfigOverview'
import IssueSystemConfig from 'components/IssueSystemConfig'
import IssueAdvancedSystemConfig from 'components/IssueAdvancedSystemConfig'


/*
    Templating
*/
import TemplateDefinitions from 'components/TemplateDefinitions'

/*
    Transactions
*/
import TransactionReports from 'components/TransactionReports'

import jwt from 'utils/jwt.js'
import authorize from 'utils/authorize.js'

export const routes = [
    { path: '/login',                               component: Login, display: 'Login',             name: 'login',  style: 'glyphicon glyphicon-home' },
    { path: '/users',                               component: Users,                               name: 'users',                             beforeEnter: authorize(jwt, ['EllipseAdmin']) },
    { path: '/reset',                               component: RequestPasswordReset,                name: 'requestReset'                       },
    { path: '/reset/:token',                        component: PasswordResetForm,                   name: 'passwordReset'                      },

    { path: '/',                                    component: Systems,                             name: 'systems'                            },

    { path: '/system/:logosid/credits/issue',       component: IssueSystemCredits,                  name: 'issue-system-credits',              beforeEnter: authorize(jwt, ['EllipseAdmin', 'CreditDistributor']) },
    { path: '/system/:logosid/credits',             component: SystemCreditsOverview,               name: 'system-credits-overview',           beforeEnter: authorize(jwt, ['EllipseAdmin', 'CreditDistributor']) },

    { path: '/system/:logosid/config/issue',        component: IssueSystemConfig,                   name: 'issue-system-config',               beforeEnter: authorize(jwt, ['EllipseAdmin', 'EllipseTech']) },
    { path: '/system/:logosid/config/advanced',     component: IssueAdvancedSystemConfig,           name: 'issue-advanced-system-config',      beforeEnter: authorize(jwt, ['EllipseAdmin', 'EllipseTech']) },
    { path: '/system/:logosid/config',              component: SystemConfigOverview,                name: 'system-config-overview',            beforeEnter: authorize(jwt, ['EllipseAdmin', 'EllipseTech']) },

    { path: '/transactionreports',                  component: TransactionReports,                  name: 'transactionreports',                beforeEnter: authorize(jwt, ['EllipseAdmin']) },
    { path: '/templates',                           component: TemplateDefinitions,                 name: 'templatedefinitions',               beforeEnter: authorize(jwt, ['EllipseAdmin']) },

]

/*

function authorize(roles){
    import jwt from 'utils/jwt.js';
    import _ from 'lodash'

    return function(to, from, next){
        debugger;
        if(_.find(roles, jwt.getRole())){
            next()
        }else{
            next(from);
        }
    }
}*/


// WEBPACK FOOTER //
// ./WebApp/routes.js